module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YMvNL5/tc-custom/9781617456749.jpg?1708745383246",
      "alt": "This image is the cover for the book Beaded Embroidery Stitching"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beaded Embroidery Stitching\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Add dimension and luster to your projects—from sewing to jewelry making to mixed-media art—with tiny, shiny treasures. ")]), _c('br'), _c('br'), _vm._v("Inspired by the magic of beads, buttons, and charms, experienced teacher Christen Brown shares eight stunning beadwork projects including brooches, bracelets, and wall hangings. "), _c('br'), _c('br'), _vm._v("This helpful visual guide to 125 bead-embroidered and bead-woven stitches categorizes each stitch by style, with a second alphabetical index included—and the robust project gallery will inspire crafters of all skill levels, from embroiderers and sewists to crazy quilters, mixed-media artists, and jewelry makers.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christen Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Christen Brown Bio: Christen Brown teaches embroidery, quilting, ribbonwork, mixed media, and beadwork in her best-selling books. With a degree in fashion design, she has shown her work in galleries and fashion shows all over the world. She lives in Escondido, California. christenbrown.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc.,\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0